import CardsEvaluacion from "./CardsEvaluacion";

const EvaluacionPerfil = () => {


const infoText = {
  text1:"Observar",
  text2: "- Relación esferas",
  text3: "- PdA++",
  text4: "- Patrones posturales",
  text5: "- Huellas de las cadenas",
}

  return (
    <>
      <CardsEvaluacion urlImage="card-perfil.png" title="Vista de Perfil" 
      text1={infoText.text1}
      text2={infoText.text2}
      text3={infoText.text3}
      text4={infoText.text4}
      text5={infoText.text5}
      htmlFor="fileUpload0"
      idDraw="drawPerfil"
      />
    </>
  );
};

export default EvaluacionPerfil;
